import { useLocalStorage } from '@uidotdev/usehooks';
import { useCallback } from 'react';

import { createLocalStorageKey } from '@/utils';

type TooltipKeys = 'showSampleDocumentTooltip' | 'showReviewPredictionsTooltip' | 'showSetupAutomaticExportBanner';

export type UseTourOpts = {
  prefixes?: (string | null | undefined)[];
};

const createPrefixedKey = (prefixes?: (string | null | undefined)[]) => {
  let keyPrefix = 'tour:';
  for (const prefix of prefixes ?? []) {
    if (prefix) {
      keyPrefix += `${prefix}:`;
    }
  }

  return keyPrefix;
};

export const useTour = ({ prefixes }: UseTourOpts = {}) => {
  const keyPrefix = createPrefixedKey(prefixes);

  const [showSampleDocumentTooltip, setShowSampleDocumentTooltip] = useLocalStorage(
    createLocalStorageKey(`${keyPrefix}showSampleDocumentTooltip`),
    true
  );
  const [showConfirmPredictionsTooltip, setShowConfirmPredictionsTooltip] = useLocalStorage(
    createLocalStorageKey(`${keyPrefix}showConfirmPredictionsTooltip`),
    true
  );
  const [showAddedToAIKnowledgeTooltip, setShowAddedToAIKnowledgeTooltip] = useLocalStorage(
    createLocalStorageKey(`${keyPrefix}showAddedToAIKnowledgeTooltip`),
    true
  );
  const [showSetupAutomaticExportBanner, setShowSetupAutomaticExportBanner] = useLocalStorage(
    createLocalStorageKey(`${keyPrefix}showSetupAutomaticExportBanner`),
    true
  );
  const [showHowToGuide, setShowHowToGuide] = useLocalStorage(
    createLocalStorageKey(`${keyPrefix}showHowToGuide`),
    true
  );
  const [showSyncWarning, setShowSyncWarning] = useLocalStorage(
    createLocalStorageKey(`${keyPrefix}showSyncWarning`),
    true
  );

  const setTooltip = useCallback(
    (prefixes: (string | null | undefined)[], key: TooltipKeys, value: string | boolean) => {
      const keyPrefix = createPrefixedKey(prefixes);
      const localStorageKey = createLocalStorageKey(`${keyPrefix}${key}`);
      localStorage.setItem(localStorageKey, value.toString());
    },
    []
  );

  return {
    setShowAddedToAIKnowledgeTooltip,
    setShowConfirmPredictionsTooltip,
    setShowHowToGuide,
    setShowSampleDocumentTooltip,
    setShowSetupAutomaticExportBanner,
    setShowSyncWarning,
    setTooltip,
    showAddedToAIKnowledgeTooltip,
    showConfirmPredictionsTooltip,
    showHowToGuide,
    showSampleDocumentTooltip,
    showSetupAutomaticExportBanner,
    showSyncWarning,
  };
};
